import { makeVar } from '@apollo/client'
import { useEffectOnce } from 'react-use'

export const isAfterHydrationVar = makeVar<boolean>(false)

const useGlobalAfterHydration = () => {
  useEffectOnce(() => {
    isAfterHydrationVar(true)
  })
}

export default useGlobalAfterHydration
